import React from "react"

import YoastSEO from "./YoastSEO"

const JambareePageWrapper = props => {
  const {
    location: { href },
    pageContext: { seo },
    children,
  } = props

  return (
    <>
      <YoastSEO ogUrl={href} seo={seo} />

      {children}
    </>
  )
}

export default JambareePageWrapper
